import React from "react";
import { withTranslation } from "react-i18next";

class NotFound extends React.Component {
    render() {
        return (this.props.t("Not found"))
    }
}

export default withTranslation()(NotFound);